<template>
    <div style="display: flex; flex-direction: column; flex: 1;">
        <MercenaryHeader :back-title="'뒤로가기'" :close-action="goBack">
            <div style="font-size: 14px; margin-right: 12px; text-align: right;"><span style="font-weight: 700;">{{ spotlightDetail.view_cnt }}명</span>이 봤습니다</div>
        </MercenaryHeader>
        <div style="flex: 1; overflow-y: scroll;" ref="main_container">
            <div style="height: 300px; position: relative;">
                <img style="object-fit: cover; width: 100%; height: 100%; position: absolute; z-index: -1;" :src="$resourcePath + spotlightDetail.thumbnail_path" alt="">
                <div style="position: relative; padding: 20px; height: 100%; display: flex; flex-direction: column; z-index: 1; justify-content: end;">
                    <div style="color: #fff; font-size: 20px; font-weight: 700; line-height: 32px; margin-bottom: 4px; word-break: break-all;">{{ spotlightDetail.title }}</div>
                    <div style="color: #bbb; font-weight: 500; font-size: 14px; line-height: 24px;">{{ spotlightDetail.name }}</div>
                </div>
            </div>
            <div style=" padding: 0 12px; padding-top: 20px;">
                <div style="margin-bottom: 20px;">
                    <div style="font-weight: 500; font-size: 14px; color: #808080; line-height: 21px;">{{ spotlightDetail.sub_title1 }}</div>
                    <div style="font-weight: 700; font-size: 20px; line-height: 32px; margin-top: 4px;">{{ spotlightDetail.sub_title2 }}</div>
                    <div @click="showTeam" v-if="isExistTeam" style="font-size: 15px; font-weight: 500; line-height: 32px; color: #5c9dff;">축구팀 보기</div>
                </div>
                <div v-if="spotlightDetail.media_path" style="border-radius: 12px; margin-bottom: 48px; overflow: hidden;">
                    <ContentsViewer :isFromHome="isFromHome" :pageType="'interview'" :contents="spotlightDetail.media_path" style="" />
                </div>
                <div style="padding-bottom: 48px;">
                    <div style="margin-bottom: 48px;" v-for="each, i in interviews" :key="i">
                        <div style="font-weight: 500; font-size: 14px; color: #808080; line-height: 21px; margin-bottom: 12px;">{{ each.q }}</div>
                        <div style="font-weight: 500; line-height: 24px; white-space: pre-line;">{{ each.a }}</div>
                    </div>
                </div>
            </div>
            <div v-if="Object.keys(spotlightDetail).length > 0" style="height: 228px; background: linear-gradient(90deg, #FF7111 0%, #EABB56 50%, #FFC39A 100%);">
                <div style="text-align: center; font-weight: 500; line-height: 24px; padding-top: 40px; font-size: 20px; font-weight: 700;">이 팀은 어떠셨나요?<br>바로 입단 요청서를 보내볼까요?</div>
                <div @click="confirmMySoccerhow" style="width: 264px; height: 56px; font-size: 14px; line-height: 56px; border-radius: 50px; text-align: center; margin: 0 auto; background-color: #210f03; font-weight: 500; color: var(--color-main); margin-top: 20px;">입단 요청서 보내기</div>
            </div>
        </div>
        <BookmarkPopup :height="204" :isShowBookmarkPopup="isShowBookmarkPopup" :closeBookmarkPopup="closeBookmarkPopup">
            <div>
                <div @click="closeBookmarkPopup" style="font-weight: 700;">닫기</div>
                <div style="text-align: center; font-weight: 500; line-height: 24px; padding-top: 24px; font-size: 20px; font-weight: 700;">이 팀은 어떠셨나요?<br>바로 입단 요청서를 보내볼까요?</div>
                <div @click="confirmMySoccerhow" style="width: 264px; height: 56px; font-size: 14px; line-height: 56px; border-radius: 50px; text-align: center; margin: 0 auto; background-color: #210f03; font-weight: 500; color: var(--color-main); margin-top: 20px;">입단 요청서 보내기</div>
            </div>
        </BookmarkPopup>
        <BookmarkPopup :height="254" :isShowBookmarkPopup="isShowRequestConfirmPopup" :closeBookmarkPopup="closeRequestConfirmPopup">
            <div>
                <div @click="closeRequestConfirmPopup" style="font-weight: 700;">닫기</div>
                <div style="margin-top: 20px; font-size: 20px; line-height: 33px; font-weight: 700; text-align: center;">만들어둔 입단 요청서가 없어요<br>새로 만들어야 해요</div>
                <div @click="showRequestJoinForm" style="width: 255px; margin: 0 auto; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">입단 요청서 만들기</div>
            </div>
        </BookmarkPopup>
        <MakeRequestJoinForm :soccerhowIdx="soccerhowIdx" :isFromReportList="isFromReportList" :isShowMakeRequestJoinForm="isShowMakeRequestJoinForm" :closeRequestJoinForm="closeRequestJoinForm"></MakeRequestJoinForm>
        <CommonPopupFrame :isBlur="true" background="#fffc" :changeBottom="0" :changeHeight="100" :isOpen="isShowRequestForm" :closeCompleteAction="closeRequestForm">
            <div @click="closeRequestForm" style="padding: 16px 20px; font-weight: 700; width: 100px;">닫기</div>
            <div style="flex: 1; overflow-y: scroll; padding: 0 12px;">
                <div style="text-align: center; margin-top: 60px; font-size: 20px; font-weight: 700; line-height: 33px; margin-bottom: 40px;">아래의 요청서를 전달할게요</div>
                <div style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; border-radius: 12px;" v-if="Object.keys(requestInfo).length > 0">
                    <CommonPost :hideOption="true" :isDetail="true" :isFeed="true" :soccerHows="requestInfo"></CommonPost>
                </div>
            </div>
            <div style="padding: 0 12px;">
                <div @click="showPayForm" style="margin-bottom: 40px; height: 56px; display: flex; justify-content: center; align-items: center; border-radius: 40px; background-color: #210f03; color: var(--color-main); font-size: 14px; font-weight: 700; margin-top: 40px;">보내기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import ContentsViewer from '@/components/common/ContentsViewer'
import BookmarkPopup from '@/components/soccerhowmain/BookmarkPopup';
import MakeRequestJoinForm from "@/components/soccerhowmain/MakeRequestJoinForm";
import CommonPost from '@/components/soccerhowmain/CommonPost'
import { SOCCER_HOW_TYPE } from '@/Constants'
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import { PUSH_ACTION } from "../../Constants";

export default {
    name: "InterviewDetail",
    components: { MercenaryHeader, CommonPost, CommonPopupFrame, MakeRequestJoinForm, ContentsViewer, BookmarkPopup },
    props: {
        spotlightIdx: {
            type: [String, Number],
            default: -1
        },
        isFromHome: {
            type: Boolean,
            default: false
        }
    },
    created() {
        if (!localStorage.getItem('interviewList')) {
            const interviewList = []
            localStorage.setItem('interviewList', JSON.stringify(interviewList))
        } else {
            this.interviewList = JSON.parse(localStorage.getItem('interviewList'))
        }
        this.getSpotlightDetail()
    },
    data() {
        return {
            spotlightDetail: {},
            interviews: [],
            isShowBookmarkPopup: false,
            isExistTeam: false,
            isShowRequestConfirmPopup: false,
            soccerhowIdx: -1,
            isFromReportList: false,
            isShowMakeRequestJoinForm: false,
            requestInfo: {},
            isShowRequestForm: false,
            mainContainerHeight: 0,
            scrollBottom: 0,
            eightyPercentScrollBottom: 0,
            interviewList: [],
            isCheckPopup: false,
            showPopup: false
        }
    },
    methods: {
        showTeam() {
            this.$GlobalStore.addModal('SoccerTeamDetail', { isModalBackTransparent: true, teamIdx: this.spotlightDetail.manager.team.idx })
        },
        showPayForm() {
            this.$GlobalStore.addModal('RequestPayForm', { selectedTeam: this.spotlightDetail.manager.team, soccerhowIdx: this.requestInfo.idx, isFromTeam: true })
        },
        detectScroll(e) {
            if ((e.target.scrollTop >= this.eightyPercentScrollBottom) && this.isExistTeam && !this.isCheckPopup) {
                this.isCheckPopup = true
                this.setLocalStorage()
            }
        },
        closeRequestForm() {
            this.isShowRequestForm = false
            this.isFromReportList = false
        },
        async confirmMySoccerhow() {
            if (!this.$Util.checkLoginAndWeb()) {
                return
            }
            const parameters = {}
            const types = [SOCCER_HOW_TYPE.SC_COUNSEL, SOCCER_HOW_TYPE.SC_JOIN, SOCCER_HOW_TYPE.SC_JOB]
            parameters.types = types

            const res = await this.$Axios.get('/api/soccerhow/mine', { params: parameters })
            if (res.data.soccerhows.length === 0) {
                this.isShowRequestConfirmPopup = true
            } else {
                this.requestInfo = res.data.soccerhows[0]
                this.isShowRequestForm = true
            }
        },
        closeRequestJoinForm() {
            this.isShowMakeRequestJoinForm = false;
        },
        sendRequestForm() {
            this.soccerhowIdx = this.requestInfo.idx
            this.isShowRequestForm = false
            this.isShowMakeRequestJoinForm = true
            this.isFromReportList = true
        },
        showRequestJoinForm() {
            this.closeRequestConfirmPopup()
            this.$GlobalStore.addModal('SelectPlayerType')
            // this.isShowMakeRequestJoinForm = true
        },
        closeRequestConfirmPopup() {
            this.isShowRequestConfirmPopup = false
        },
        goBack() {
            if (!this.showPopup) {
                this.isShowBookmarkPopup = true
                return
            }
            // if (this.isExistTeam && !this.isCheckPopup) {
            //     this.setLocalStorage()
            //     return
            // }
            this.$GlobalStore.closeLastModal()
        },
        setLocalStorage() {
            this.isShowBookmarkPopup = true
            this.interviewList.push(this.spotlightDetail)
            localStorage.setItem('interviewList', JSON.stringify(this.interviewList))
        },
        closeBookmarkPopup() {
            this.isShowBookmarkPopup = false
            // this.isCheckPopup = true
            setTimeout(() => {
                this.$GlobalStore.closeLastModal()
            }, 500);
        },
        async getSpotlightDetail() {
            const parameters = {}
            parameters.spotlight_idx = this.spotlightIdx

            const res = await this.$Axios.get('/api/spotlight/detail', { params: parameters })

            const spotlightDetail = res.data.spotlight
            // const interviewList = localStorage.getItem('interviewList')
            this.spotlightDetail = spotlightDetail
            this.interviews = JSON.parse(spotlightDetail.interviews)
            console.log(this.interviews)
            this.interviewList.forEach(item => {
                if (item.idx === this.spotlightDetail.idx) {
                    this.isCheckPopup = true
                }
            })

            if (this.spotlightDetail.manager.team) {
                this.isExistTeam = true
            }
            // this.$nextTick(() => {
            //     this.mainContainerHeight = this.$refs.main_container.scrollHeight
            //     this.scrollBottom = this.$refs.main_container.scrollHeight - this.$refs.main_container.clientHeight
            //     this.eightyPercentScrollBottom = this.scrollBottom * 0.8
            // })
        },
    },
    mounted() {
        this.$Util.checkAppLinkPageShow(PUSH_ACTION.SPORTLIGHT_DETAIL, this.spotlightIdx);
    }
}
</script>